var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__header",attrs:{"itemprop":_vm.SCHEMA_ITEM_PROP.NAME}},[_c('SfHeading',{staticClass:"sf-heading--no-underline",attrs:{"title":_vm.productTitle,"level":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }